import { Pie } from "@ant-design/plots"
import { wrap } from "@sentry/react"
import { Card, ComponentState, Skeleton, Text } from "components/common"
import Empty from "components/common/empty/empty"
import { StatsHeading } from "features/reports/components"
import { t } from "i18next"
import { removeUnderscore } from "utils"

export default function PerformanceDonutChart(props) {
  const { queryObj, loadType, title, extraTitle, useQuery, eventTypes, totalCount, calendarChart, from } = props

  const defaultQuery = () => ({
    data: null,
    isFetching: false,
    error: null,
    refetch: () => {},
  })
  const queryFunction = useQuery || defaultQuery
  const { data, isFetching, error, refetch } = queryFunction({ ...queryObj, load: loadType }, {})

  const chartData = calendarChart
    ? eventTypes.map(event => ({
        ...event,
        type: removeUnderscore(event?.type?.toUpperCase() || event?.title?.toUpperCase() || ""),
        percentage: event?.percentage || 0,
      }))
    : data?.[loadType]?.data || []

  const config = {
    data: chartData,
    angleField: "value",
    colorField: "type",
    radius: calendarChart ? 0.7 : 0.8,
    innerRadius: calendarChart ? 0.6 : 0.7,
    label: calendarChart
      ? {
          content: "{value}",
        }
      : {
          type: "inner",
          offset: "-50%",
          content: "{value}",
          autoRotate: false,
          style: { textAlign: "center" },
        },
    interactions: [{ type: "element-active" }],
    statistic: {
      title: calendarChart
        ? false
        : {
            offsetY: -20,
            content: title,
            style: { fontSize: 14 },
          },
      content: {
        content: calendarChart ? `${totalCount || 0} ${t("events")}` : false,
        style: calendarChart
          ? { fontSize: 16, fontWeight: "bold" }
          : { whiteSpace: "pre-wrap", overflow: "hidden", textOverflow: "ellipsis" },
      },
    },
    ...(from == "calendar"
      ? {
          legend: {
            position: "bottom",
            flipPage: false,
          },
        }
      : { legend: false }),
  }

  const getTooltipContent = () => {
    if (!calendarChart && data?.[loadType]?.tooltip?.length) {
      return data[loadType].tooltip?.map((item, index) => (
        <Text key={index} strong block>{`${item.label}:  ${item?.value}`}</Text>
      ))
    }
    return false
  }

  return !!error ? (
    <Card>
      <ComponentState
        description={error.message}
        status={error.status}
        btnLoading={isFetching}
        onClick={() => refetch()}
      />
    </Card>
  ) : (
    <Card
      title={isFetching ? <Skeleton /> : <StatsHeading title={title} showValue={false} />}
      {...(from != "calendar" && {
        extra: isFetching ? (
          <Skeleton />
        ) : (
          <StatsHeading type="extra" title={extraTitle} value={data?.[loadType]?.total} content={getTooltipContent()} />
        ),
      })}
      headStyle={{ borderBottom: 0 }}
      bodyStyle={{
        direction: "ltr",
        padding: calendarChart ? "24px 8px" : undefined,
      }}
    >
      {isFetching ? (
        <Skeleton type="input" width={500} height={300} active />
      ) : data?.[loadType]?.total === 0 ? (
        <Empty description={t("No records found")} />
      ) : (
        <Pie {...config} height={calendarChart ? 300 : 320} />
      )}
    </Card>
  )
}
